module.exports = __webpack_public_path__ + "static/img/coupons-10.61d193d6.png";